module.exports = __webpack_public_path__ + "img/pathElipse.d5076bce.svg";